import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  clientDashboard,
  clientProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ClientDashboardAddNewRequirementAddProjectDetails from "./ClientDashboardAddNewRequirementAddProjectDetails";
import ClientDashboardAddNewRequirementAddResourceDetails from "./ClientDashboardAddNewRequirementAddResourceDetails";
import BreadcrumbMenu from "../common/BreadcrumbMenu";

export default function ClientDashboardAddNewRequirement() {
  const [activeTabIndex, setActiveTabIndex] = useState(
    isNaN(
      parseInt(localStorage.getItem("clientDashboardAddNewRequirementTabIndex"))
    )
      ? 0
      : parseInt(
          localStorage.getItem("clientDashboardAddNewRequirementTabIndex")
        )
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOnSelect = (val) => {
    // clientDashboardAddNewRequirementTabIndex
    localStorage.setItem("clientDashboardAddNewRequirementTabIndex", val);
    setActiveTabIndex(val);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem("clientDashboardAddNewRequirementTabIndex");
    };
  }, []);

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={clientDashboard}
        profileLink={clientProfile}
        activeLink={activeLinkDashboard}
      />
      <div className="sidenavbar-active-menu-page client-dashboard-add-new-requirement-div">
        <BreadcrumbMenu
          menuObj={[
            {
              title: "Dashboard",
              type: "goBackButton",
            },
            {
              title: "Create New Requirement",
            },
          ]}
        />
        <h2 className="font-48-NunitoSans-600">
          <Link to={clientDashboard}>
            <img
              src={"/img/desktop/icons/white-left-arrow-icon.svg"}
              alt="left-arrow"
              className="client-dashboard-add-new-requirement-left-arrow"
            />
          </Link>
          Create New Requirement
        </h2>
        <div className="mt-platform-tabs pt-25">
          <Tabs
            // defaultIndex={parseInt(
            //   localStorage.getItem("clientDashboardAddNewRequirementTabIndex")
            // )}
            onSelect={handleOnSelect}
            selectedIndex={activeTabIndex}
          >
            <TabList>
              <Tab>Project Details</Tab>
              <Tab>Resource Details</Tab>
            </TabList>
            <TabPanel>
              <ClientDashboardAddNewRequirementAddProjectDetails
                handleOnSelect={handleOnSelect}
              />
            </TabPanel>
            <TabPanel>
              <ClientDashboardAddNewRequirementAddResourceDetails />
            </TabPanel>
          </Tabs>
        </div>{" "}
      </div>{" "}
    </div>
  );
}
